export const TRACKING_NAMESPACE = 'App Governance';
export const EVENTS = {
  PAGE_VIEWED: 'Page Viewed',
  PANEL_INTERACTED: 'Panel Interacted'
};
export const SCREENS = {
  APPROVE_APP_PANEL: 'Approve App Panel',
  MANAGEMENT_MODAL_PANEL: 'Management Modal Panel'
};
export const ACTIONS = {
  APP_APPROVED: 'App Approved',
  APP_REVOKED: 'App Revoked',
  USER_UNINSTALLED: 'User Uninstalled',
  INSTALL_PERMISSIONS_SAVED: 'Install Permissions Saved',
  DATA_PERMISSIONS_SAVED: 'Data Permissions Saved'
};
export const SUBSCREENS = {
  INSTALL_PERMISSIONS: 'Install Permissions',
  DATA_PERMISSIONS: 'Data Permissions',
  INSTALLED_BY: 'Installed By',
  REVOKE_APPROVAL: 'Revoke Approval'
};